// The card's number badge already reflects the source's position, so drop any
// leading enumeration prefix (e.g. "6. Report.pdf" -> "Report.pdf") from the
// displayed name. Also cleans up older chats persisted with numbered labels.
export function displaySourceLabel(label: string): string {
  return label.replace(/^\s*\d+\.\s+/, '');
}

/** Mark a truncated excerpt as incomplete. Sentence-final punctuation stays as-is. */
export function formatCitationPreview(preview: string): string {
  const trimmed = preview.trimEnd();
  if (trimmed === '' || /[.!?…]$/.test(trimmed)) {
    return trimmed;
  }
  return `${trimmed}…`;
}

/** Inline assistant citation token such as `[[1]]`. */
export const CITATION_TOKEN = /(\[\[\d+\]\])/g;

// Strips the inline [[n]] citation tokens so copied reply text reads cleanly.
export function stripCitationTokens(text: string): string {
  return text
    .replace(CITATION_TOKEN, '')
    .replace(/[ \t]{2,}/g, ' ')
    .trim();
}
